export function getLookingForTicketsMessage(name: string) {
  return `Hello, I am looking for tickets for the ${name}.`;
}
